// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-content[data-v-771ae402]{line-height:1.75}.e-content iframe[data-v-771ae402]{width:100%;height:30rem}@media screen and (max-width:1024px){.e-content iframe[data-v-771ae402]{height:11rem}}", ""]);
// Exports
module.exports = exports;
